import FC from "assets/images/game/fishing/fh-fc.png";
import JILI from "assets/images/game/fishing/fh-jili.png";
import SG from "assets/images/game/fishing/fh-sg.png";
import ACE from "assets/images/game/fishing/fishing-ace.png";
import { SubGameType } from "types/game";

export const listGameFishing: SubGameType[] = [
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "FC",
    type: "FH",
    featured: "NO",
    new_arrive: "NO",
    picture: FC
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "JILI",
    type: "FH",
    featured: "NO",
    new_arrive: "NO",
    picture: JILI
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "SG",
    type: "FH",
    featured: "NO",
    new_arrive: "NO",
    picture: SG
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "ACEM",
    type: "FH",
    featured: "NO",
    new_arrive: "NO",
    picture: ACE
  }
];
